import * as React from 'react';
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    Radio,
    RadioGroup,
    TextField
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";

interface IProps {
    data?: any;
    isAmazonCustomer?: any;
}

interface IState {
    addressLine1: any,
    addressLine2: any,
    biologicalSex: any,
    city: any,
    country: any,
    countryCode: any,
    dateOfBirth: any,
    emailId: any,
    firstName: any,
    lastName: any,
    middleName: any,
    mobileNumber: any,
    preferredGender: any,
    preferredName: any,
    preferredPronoun: any,
    programToEnroll: any,
    sexAtBirth: any,
    state: any,
    suffix: any,
    zipCode: any
}

class CommonFieldsSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            addressLine1: '601 New Jersey Ave NW',
            addressLine2: 'Suite 900',
            biologicalSex: 'Male',
            city: 'Washington',
            country: 'US',
            countryCode: '+1',
            dateOfBirth: '1980-10-10',
            emailId: '',
            firstName: '',
            lastName: '',
            middleName: '',
            mobileNumber: '',
            preferredGender: 'Nonbinary',
            preferredName: '',
            preferredPronoun: 'They/Them/Their',
            programToEnroll: 'PHARMACY',
            sexAtBirth: 'Male',
            state: 'DC',
            suffix: '',
            zipCode: '20001'
        };

        this.handleAddressLine1 = this.handleAddressLine1.bind(this);
        this.handleAddressLine2 = this.handleAddressLine2.bind(this);
        this.handleBiologicalSex = this.handleBiologicalSex.bind(this)
        this.handleCity = this.handleCity.bind(this);
        this.handleCountry = this.handleCountry.bind(this);
        this.handleDateOfBirth = this.handleDateOfBirth.bind(this)
        this.handleEmailId = this.handleEmailId.bind(this);
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleMiddleName = this.handleMiddleName.bind(this);
        this.handleMobileNumber = this.handleMobileNumber.bind(this);
        this.handlePreferredGender = this.handlePreferredGender.bind(this);
        this.handlePreferredName = this.handlePreferredName.bind(this);
        this.handlePreferredPronoun = this.handlePreferredPronoun.bind(this);
        this.handleProgramToEnroll = this.handleProgramToEnroll.bind(this);
        this.handleSexAtBirth = this.handleSexAtBirth.bind(this)
        this.handleState = this.handleState.bind(this);
        this.handleSuffix = this.handleSuffix.bind(this);
        this.handleZipCode = this.handleZipCode.bind(this);
    }

    public render() {
        return (
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <InputLabel style={{
                        color: "red",
                        fontSize: 18,
                        fontWeight: "bold",
                    }}>Profile</InputLabel>
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="First Name (Required)"
                        variant="outlined"
                        value={this.state.firstName}
                        onChange={this.handleFirstName}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Middle Name (Optional)"
                        variant="outlined"
                        value={this.state.middleName}
                        onChange={this.handleMiddleName}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Last Name (Required)"
                        variant="outlined"
                        value={this.state.lastName}
                        onChange={this.handleLastName}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Suffix (Optional)"
                        variant="outlined"
                        value={this.state.suffix}
                        onChange={this.handleSuffix}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        label="Date of birth (Required)"
                        type="date"
                        value={this.state.dateOfBirth}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{width: 225}}
                        onChange={this.handleDateOfBirth}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Email Id (Required)"
                        variant="outlined"
                        value={this.state.emailId}
                        onChange={this.handleEmailId}
                    />
                </Grid>

                <Grid item xs>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Sex At Birth</FormLabel>
                        <RadioGroup aria-label="sexAtBirth" name="sexAtBirth" value={this.state.sexAtBirth}
                                    onChange={this.handleSexAtBirth}
                                    style={{width: 225}}>
                            <FormControlLabel value="Female" control={
                                <Radio/>
                            } label="Female"/>
                            <FormControlLabel value="Male" control={
                                <Radio/>
                            } label="Male"/>
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Mobile Number (Required)"
                        variant="outlined"
                        value={this.state.mobileNumber}
                        onChange={this.handleMobileNumber}
                        inputProps={{
                            maxLength: 15
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">+1</InputAdornment>,
                        }}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Address Line 1 (Required)"
                        variant="outlined"
                        value={this.state.addressLine1}
                        onChange={this.handleAddressLine1}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Address Line 2 (Optional)"
                        variant="outlined"
                        value={this.state.addressLine2}
                        onChange={this.handleAddressLine2}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="City (Required)"
                        variant="outlined"
                        value={this.state.city}
                        onChange={this.handleCity}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="State (Required)"
                        variant="outlined"
                        value={this.state.state}
                        onChange={this.handleState}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Country (Required)"
                        variant="outlined"
                        value={this.state.country}
                        onChange={this.handleCountry}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="ZipCode (Required)"
                        variant="outlined"
                        value={this.state.zipCode}
                        onChange={this.handleZipCode}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Preferred Name (Required)"
                        variant="outlined"
                        value={this.state.preferredName}
                        onChange={this.handlePreferredName}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Preferred Gender (Optional)"
                        variant="outlined"
                        value={this.state.preferredGender}
                        onChange={this.handlePreferredGender}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Preferred Pronoun (Optional)"
                        variant="outlined"
                        value={this.state.preferredPronoun}
                        onChange={this.handlePreferredPronoun}
                    />
                </Grid>

                <Grid item xs>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">BiologicalSex</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.biologicalSex}
                                    onChange={this.handleBiologicalSex}
                                    style={{width: 225}}>
                            <FormControlLabel value="Female" control={
                                <Radio/>
                            } label="Female"/>
                            <FormControlLabel value="Male" control={
                                <Radio/>
                            } label="Male"/>
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Program To Enroll (Required)"
                        variant="outlined"
                        value={this.state.programToEnroll}
                        onChange={this.handleProgramToEnroll}
                    />
                </Grid>

            </Grid>
        );
    }

    public handleFirstName(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({firstName: event.target.value})
    }

    public handleMiddleName(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({middleName: event.target.value})
    }

    public handleLastName(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({lastName: event.target.value})
    }

    public handleSuffix(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({suffix: event.target.value})
    }

    public handleDateOfBirth(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({dateOfBirth: event.target.value})
    }

    public handleEmailId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({emailId: event.target.value})
    }

    public handleSexAtBirth(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({sexAtBirth: event.target.value})
    }

    public handleBiologicalSex(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({biologicalSex: event.target.value})
    }

    public handleMobileNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const value = event.target.value.replace(/\D/g, "").slice(-10)
        this.setState({mobileNumber: value})
    }

    public handleAddressLine1(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({addressLine1: event.target.value})
    }

    public handleAddressLine2(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({addressLine2: event.target.value})
    }

    public handleCity(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({city: event.target.value})
    }

    public handleState(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({state: event.target.value})
    }

    public handleCountry(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({country: event.target.value})
    }

    public handleZipCode(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({zipCode: event.target.value})
    }

    public handleProgramToEnroll(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({programToEnroll: event.target.value})
    }

    public handlePreferredName(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({preferredName: event.target.value})
    }

    public handlePreferredGender(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({preferredGender: event.target.value})
    }

    public handlePreferredPronoun(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({preferredPronoun: event.target.value})
    }

    public getState() {
        return this.state;
    }
}

export default CommonFieldsSection
